export default __webpack_public_path__ + "static/AppBeers9-74ffe2bf7095f249efcbaba261dbcff4.png";